"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentationOnStageSelector = void 0;
var _constants = require("@studio/constants");
var presentationOnStageSelector = exports.presentationOnStageSelector = function presentationOnStageSelector(state) {
  var _state$program;
  var presentationLayer = (_state$program = state.program) === null || _state$program === void 0 || (_state$program = _state$program.layers) === null || _state$program === void 0 ? void 0 : _state$program.find(function (layer) {
    var _layer$source;
    return ((_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source.type) === _constants.PDF_FILE;
  });
  var source = presentationLayer === null || presentationLayer === void 0 ? void 0 : presentationLayer.source;
  var _ref = source !== null && source !== void 0 ? source : {},
    presentationValue = _ref.value,
    title = _ref.title,
    id = _ref._id;
  var url = presentationValue === null || presentationValue === void 0 ? void 0 : presentationValue.url;
  return {
    isPresentationOnStage: presentationLayer !== undefined,
    presentationValue: presentationValue,
    title: title,
    id: id,
    url: url
  };
};